var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticClass:"new-app",attrs:{"id":"inspire"}},[(_vm.showNav)?_c('div',[(this.$router.currentRoute.path != '/login')?_c('SideNav',{attrs:{"activities":_vm.activities}}):_vm._e()],1):_vm._e(),_c('v-main',{class:_vm.mainClasses,attrs:{"id":"main"}},[_c('router-view',{on:{"updateAudit":_vm.updateAudit}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }